/**
 * IMPORTS
 */

import { useQuery } from "@tanstack/react-query";

import { useStoreZustandUserAuth } from "@/store-zustand/user-auth";

import { handleGetVideoTutorial } from "@/domain/use-cases/videos-tutorias";
import { IVideoTutorialResponse } from "@/interface/videos-tutorias";

function useBuscarVideoTutorial(isModalOpen: boolean) {
  const { token: accessToken } = useStoreZustandUserAuth();

  const {
    data: videoResponse,
    isLoading,
    isError,
    refetch,
  } = useQuery<IVideoTutorialResponse>({
    queryKey: ["videos-tutorias"],
    queryFn: async () => {
      const response = await handleGetVideoTutorial(accessToken!);
      return response as IVideoTutorialResponse;
    },
    enabled: !!accessToken && isModalOpen,
  });

  return {
    videoUrl: videoResponse?.data?.url ?? null,
    videoNome: videoResponse?.data?.nome ?? null,
    isLoading,
    isError,
    refetch,
  };
}

/**
 * EXPORTS
 */
export { useBuscarVideoTutorial };
